import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Regiment } from '../models/regiment';
import { State } from '../models/state';
import { BranchOfService } from '../models/branchOfService';
import { WriteOrdinalSuffixOfNumber } from 'starbase-launcher';
import { UnitArmies } from '../models/unitLinking';
import { filterWindowSlideIn } from '../animations';
import { BreakpointService, BreakpointState } from '../breakpoint.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-unit-filter',
  templateUrl: './unit-filter.component.html',
  styleUrls: ['./unit-filter.component.css'],
  animations: [ filterWindowSlideIn ]
})
export class UnitFilterComponent implements OnInit {
  /* These are to be passed along to child UnitPicker component */
  @Input() regiments: Regiment[];
  @Input() states: State[];
  @Input() branches: BranchOfService[];
  @Input() coLetters: string[];
  @Input() activeUnitFilters: {
    army: UnitArmies | undefined;
    corps: number;
    regiment: Regiment;
    state: State;
    branch: BranchOfService;
    coLetters: string[];
  }[] = [];
  /* - - */

  // @Output() filtersSet: EventEmitter<object[]> = new EventEmitter<object[]>();
  @Output() closePressed: EventEmitter<any> = new EventEmitter<any>();
  @Output() activeUnitFiltersChange: EventEmitter<any> = new EventEmitter<any>();

  public ordinalSuffix = WriteOrdinalSuffixOfNumber;
  unitArmies = UnitArmies;

  show: string; // animate trigger

  private _subscription;
  isHandset: boolean = false;

  constructor(private breakpointService: BreakpointService) { }

  ngOnInit() {
    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
     )


    this.show = 'in';
  }

  public addToFilterList(unit: {
    army: UnitArmies | undefined;
    corps: number;
    regiment: Regiment;
    state: State;
    branch: BranchOfService;
    coLetters: string[];
  }) {
    this.activeUnitFilters = [...this.activeUnitFilters, unit];
    this.activeUnitFiltersChange.emit(this.activeUnitFilters);
    // this.filtersSet.emit(this.activeUnitFilters);
  }
  public removeFromFilterList(index: number) {
    this.activeUnitFilters = this.activeUnitFilters.filter((_, i) => i !== index);
    this.activeUnitFiltersChange.emit(this.activeUnitFilters); 
    // this.filtersSet.emit(this.activeUnitFilters);
  }

  closeFilterBox(clear: boolean): void {
    if (clear) {
      this.activeUnitFilters = [];
      this.activeUnitFiltersChange.emit(this.activeUnitFilters);
      // this.filtersSet.emit(this.activeUnitFilters);
    }
    this.show = 'out';
    setTimeout(() =>
      this.closePressed.emit(), 300);
  }

}
